import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PanelType} from "../info-panel/info-panel.component";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {CommonModule} from "@angular/common";
import {FlexModule} from "@angular/flex-layout";

@Component({
  selector: 'app-expanding-info-panel',
  templateUrl: './expanding-info-panel.component.html',
  styleUrls: ['./expanding-info-panel.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    CommonModule,
    FlexModule
  ]
})
export class ExpandingInfoPanelComponent {
  protected readonly PanelType = PanelType;

  @Input() type!: PanelType;
  @Input() fullWidth: boolean = false;
  @Input() panelClass?: string;
  @Input() iconClass?: string;

  @Input() buttons: boolean = true;
  @Input() buttonLabels?: (string | null)[] = [];
  @Input() buttonDisabled?: (boolean)[] = [];

  @Output() emitEvent = new EventEmitter<number>();
  @Output() onDisplayExpanded = new EventEmitter<boolean>();

  isExpanded = false;

  getPanelType(): { iconClass: string, icon: string } {
    switch (this.type) {
      case PanelType.DISABLED:
        return {iconClass: 'disabled-icon', icon: 'cancel'};
      case PanelType.WARN:
        return {iconClass: 'warn-icon', icon: 'error'};
      case PanelType.ERROR:
        return {iconClass: 'error-icon', icon: 'cancel'};
      case PanelType.INFO:
        return {iconClass: 'info-icon', icon: 'info'};
      default:
        return {iconClass: 'info-icon', icon: 'info'};
    }
  }

  get showButtons(): boolean {
    return !!this.buttonLabels?.length && this.buttons;
  }

  emit(index: number) {
    this.emitEvent.emit(index);
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
    this.onDisplayExpanded.emit(this.isExpanded);
  }

  protected readonly Boolean = Boolean;
}
